import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { FaClipboardList, FaVial, FaBoxOpen, FaHourglassHalf, FaBan, FaCircle } from 'react-icons/fa';
import { MdDoneAll } from 'react-icons/md';

const OrderTimeline = ({ timeline = [] }) => {
    const { t } = useTranslation();
    if (!timeline || timeline.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-8 text-gray-400">
                <p className="text-sm">{t('No timeline history available')}</p>
            </div>
        );
    }

    const getStatusStyle = (status) => {
        const statusLower = status?.toLowerCase() || '';
        if (statusLower === 'order') {
            return {
                bg: 'bg-black',
                border: 'border-black',
                text: 'text-black',
                icon: <FaClipboardList className="text-[10px]" />
            };
        }
        const successActions = ['active', 'completed', 'approved', 'approve', 'uploaded internal result approved', 'uploaded external result approved', 'sample collected', 'sample', 'received', 'received-external', 'processing'];

        if (successActions.some(s => statusLower.includes(s))) {
            let icon = <MdDoneAll className="text-[12px]" />;
            if (statusLower.includes('sample')) icon = <FaVial className="text-[10px]" />;
            if (statusLower.includes('received')) icon = <FaBoxOpen className="text-[10px]" />;

            return {
                bg: 'bg-teal-600',
                border: 'border-teal-600',
                text: 'text-teal-700',
                icon: icon
            };
        }

        const warning = ['pending', 'in progress', 'hold'];
        if (warning.some(s => statusLower.includes(s))) {
            return {
                bg: 'bg-orange-500',
                border: 'border-orange-500',
                text: 'text-orange-600',
                icon: <FaHourglassHalf className="text-[10px]" />
            };
        }

        const danger = ['cancelled', 'cancelled-external', 'rejected'];
        if (danger.some(s => statusLower.includes(s))) {
            return {
                bg: 'bg-red-500',
                border: 'border-red-500',
                text: 'text-red-600',
                icon: <FaBan className="text-[10px]" />
            };
        }

        return {
            bg: 'bg-teal-600',
            border: 'border-teal-600',
            text: 'text-teal-700',
            icon: <FaCircle className="text-[6px]" />
        };
    };

    return (
        <div className="w-full">
            <div className="relative">
                <div className="space-y-1">
                    {timeline.map((item, index) => {
                        const styles = getStatusStyle(item.status || item.action);
                        const isLast = index === timeline.length - 1;

                        return (
                            <div key={index} className="flex gap-4 relative">
                                {!isLast && (
                                    <div className="absolute ltr:left-[7px] rtl:right-[7px] top-[20px] w-[2px] h-[calc(100%-8px)] bg-gray-200" />
                                )}

                                <div className="relative mt-1.5 flex-shrink-0">
                                    <div className={`w-3.5 h-3.5 rounded-full border-2 border-white ring-1 ring-gray-200 ${styles.bg}`} />
                                </div>

                                <div className="flex-1 pb-3 flex items-start justify-between gap-4 border-b border-gray-50 last:border-0">
                                    <div className="flex flex-col">
                                        <div className="flex items-center gap-2">
                                            <span className={`text-[13px] font-bold uppercase tracking-wider ${styles.text}`}>
                                                {item.action_reason || item.action || item.status}
                                            </span>
                                            {item.created_at && (
                                                <span className="text-[13px] text-gray-500 font-bold">
                                                    • {moment(item.created_at).format('DD MMM, HH:mm')}
                                                </span>
                                            )}
                                        </div>

                                    </div>

                                    <div className="flex-shrink-0">
                                        <span className={`text-[12px] px-2 py-0.5 rounded border rounded-full ${styles.text} ${styles.border} bg-white opacity-80 font-semibold`}>
                                            {item.status || item.action}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default OrderTimeline;
